// removed by extract-text-webpack-plugin
module.exports = {"active":"header__active-3PYZQ"};


//////////////////
// WEBPACK FOOTER
// ./components/account/orders/orders-navigation/collapse/header/header.css
// module id = 769
// module chunks = 0